import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { hideCardRef } from "../../../helpers";
import * as yup from "yup";
import { useSelector } from "react-redux";
import { selectAppraisal } from "../../../../store/selectors";
import greenTick from "../../../../images/icon--greenTick-clearCircle.svg";

export const TellUsMoreModal = ({
  tellUsMoreCardRef,
  handleTellUsMoreSubmit
}) => {
  const [tellUsMoreCharacterCount, setTellUsMoreCharacterCount] = useState(0);
  const { tellUsMoreSubmitted, tellUsMoreError } = useSelector(selectAppraisal);
  const MAX_CHARACTER_COUNT = 200;

  const wordCount = (event) => {
    setTellUsMoreCharacterCount(event.target.value.length);
  };

  const schema = yup.object().shape({
    tellUsMore: yup
      .string()
      .max(MAX_CHARACTER_COUNT, "The maximum number of characters is 200")
      .required(`Enter the extra features your car has before submitting`)
  });

  const {
    register,
    handleSubmit,
    formState: { errors }
  } = useForm({
    resolver: yupResolver(schema)
  });

  return (
    <div className="modal__tell-us-more" ref={tellUsMoreCardRef}>
      <div
        className={`modal-content__tell-us-more sl:ch-pa--4 ch-ph--3 ch-pb--4 ch-pt--3 ch-card`}
      >
        <div className="ch-display--flex ch-justify-content--end">
          <div
            className="icon__close"
            onClick={() => hideCardRef(tellUsMoreCardRef)}
          />
        </div>
        {!tellUsMoreSubmitted ? (
          <form onSubmit={handleSubmit(handleTellUsMoreSubmit)}>
            <div className="ch-display--flex ch-flex-flow--column-nowrap ch-align-items--stretch">
              <p className="ch-fs--3 sl:ch-fs--4 ch-text--bold ch-mb--0">
                Tell us more about your car
              </p>
              <p className="ch-fx--2 sl:ch-fs--3 ch-mb--3 ch-color--grey-6">
                List any extra features or add-ons your car has.
              </p>
              {(errors?.tellUsMore || tellUsMoreError) && (
                <span className="ch-color--ac-red ch-text--bold ch-fx--2 sl:ch-fs--3 ch-mb--1">
                  {errors?.tellUsMore?.message || tellUsMoreError}
                </span>
              )}
              <div
                className={`ch-form__group ${
                  errors?.tellUsMore ? "ch-form__group--error" : ""
                }`}
              >
                <textarea
                  name="tellUsMore"
                  className="ch-form__control tell-us-more--input"
                  type="text"
                  id="tellUsMore"
                  {...register("tellUsMore")}
                  autoComplete="off"
                  placeholder="E.g Mini Cooper Chilli pack, leather seats etc"
                  maxLength={MAX_CHARACTER_COUNT}
                  onChange={wordCount}
                />
              </div>
              <div className="ch-display--flex ch-justify-content--end">
                <p className="ch-mb--0 ch-fs--2 ch-color--grey-5">{`You have ${
                  MAX_CHARACTER_COUNT - tellUsMoreCharacterCount
                } characters remaining`}</p>
              </div>
              <input
                className={`ch-btn ch-btn--success ch-mt--2 ch-width--12 modal-content__tellUsMore--button`}
                type="submit"
                value="Submit"
              />
            </div>
          </form>
        ) : (
          <div className="ch-display--flex ch-flex-flow--column-nowrap ch-alert ch-alert--success sl:ch-mt--2 ch-mt--3 sl:ch-mb--0 ch-mb--3">
            <div className="ch-display--flex ch-justify-content--center">
              <img
                className="tell-us-more--icon-success"
                src={greenTick}
                alt="green tick"
              />
            </div>
            <p className="ch-fs--2">
              Thank you. This information will be sent to your Product
              Consultant to review.
            </p>
          </div>
        )}
      </div>
    </div>
  );
};
